module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("kt19q"))).then(() => parcelRequire('hEqeo'));